import { ReactElement, useEffect, useRef } from 'react';
import { isEmpty } from 'lodash';

import { icon_close_large, icon_envelope } from '@gn-audio/icons';
import { SiteFeature } from '@gn-audio/jss-core';

import useFallbackTranslation from '../../../utils/hooks/useFallbackTranslation';
import { FeatureToggle } from '../../FeatureToggle';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { useBasket } from '../BasketContext/useBasket';
import EmailCart from './EmailCart';

import styles from '../Basket.module.css';

const Header = (): ReactElement | null => {
  const { isBasketOpen, basket, toggleBasket, toggleEmailCart } = useBasket();
  const { t } = useFallbackTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const isBasketEmpty = isEmpty(basket?.product_items);

  useEffect(() => {
    if (isBasketOpen) {
      buttonRef.current?.focus();
    }
  }, [isBasketOpen]);

  return (
    <div className={styles.header}>
      <span className={styles.yourCart} id="modal_basket_title">
        {t('cart.YourCart')}
      </span>
      <div className="flex-0 space-between flex flex-row items-center">
        <FeatureToggle featureName={SiteFeature.SfccBasketSendByEmail}>
          {!isBasketEmpty ? (
            <button
              className="flex-0 mr-4 flex items-center justify-center"
              onClick={toggleEmailCart}
            >
              <JabraIcon Icon={icon_envelope} className="mr-1 h-7" />{' '}
              <span className={styles.emailCart}>{t('cart.EmailBasket')}</span>
            </button>
          ) : null}
        </FeatureToggle>
        {isBasketOpen ? (
          <button
            className="p-3"
            ref={buttonRef}
            onClick={toggleBasket}
            aria-label={t('topmenu.Close')}
            title={t('topmenu.Close')}
          >
            <JabraIcon Icon={icon_close_large} className="h-6" />
          </button>
        ) : null}
      </div>
      <FeatureToggle featureName={SiteFeature.SfccBasketSendByEmail}>
        <EmailCart />
      </FeatureToggle>
    </div>
  );
};

export default Header;
